import React from 'react';
import { Grid } from '@material-ui/core';
import TextField from "@material-ui/core/TextField";

const GPICreditCardFields = () => {
    return (
        <>
            <Grid item xs={12}>
                <TextField label="Card Number" name="ccnumber" variant="outlined"
                    required fullWidth InputLabelProps={{shrink: true}}
                    InputProps={{
                        inputComponent: () => {
                            return <div id="card-number-gpi" data-cy="credit-card-number-input-container"></div>
                        },
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField label="Expiration Date" name="ccexp" variant="outlined"
                    required fullWidth InputLabelProps={{shrink: true}}
                    InputProps={{
                        inputComponent: () => {
                            return <div id="card-expiration-gpi" data-cy="credit-card-expiration-date-input-container"></div>
                        },
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField label="CVC Code" name="cvc" variant="outlined"
                    required fullWidth InputLabelProps={{shrink: true}}
                    InputProps={{
                        inputComponent: () => {
                            return <div id="card-cvv-gpi" data-cy="credit-card-cvc-input-container"></div>
                        },
                    }}
                />
            </Grid>
        </>
    )
};

export default React.memo(GPICreditCardFields);
